module.exports = __webpack_public_path__ + "static/media/flipTheCards_3.bb50c30b.mp3";